import React, { Component } from 'react';
import ProjectsMenu from './projectsMenu';

export default class Projects extends Component {
  render() {
    return (
      <>
      <ProjectsMenu />
      </>
    )
  }
}
